import { matchPath } from 'react-router-dom';
import {
  ACCOUNT_PREFERENCES_LANGUAGE_REGION_PATH,
  ACCOUNT_PROFILE_PERSONAL_PATH,
} from '~/common/models/pages/accountPages.model';
import { SETTINGS_VIEW_PATH } from '~/common/models/pages/settingsPages.model';
import { SUPPORT_FAQS_PATH } from '~/common/models/pages/supportPages.model';

export const GMF_ORGANIZATIONS_PATH = '/organizations';

/** Limits GMF advisors to the organization list and details, not child resources. */
export const isGmfOrganizationPath = (pathname: string): boolean =>
  [GMF_ORGANIZATIONS_PATH, '/organizations/:organizationsId'].some(
    (path) => !!matchPath({ path, end: true }, pathname)
  );

/** Allows self-account pages without widening customer or Contact access. */
export const isGmfAccountPath = (pathname: string): boolean =>
  [
    ACCOUNT_PROFILE_PERSONAL_PATH,
    ACCOUNT_PREFERENCES_LANGUAGE_REGION_PATH,
    SETTINGS_VIEW_PATH,
    SUPPORT_FAQS_PATH,
  ].some((path) => !!matchPath({ path, end: true }, pathname));

/** Enables content only after the signed-in flag context has resolved. */
export const isGmfRolloutEnabled = (
  value: unknown,
  isUserContextIdentified: boolean
): boolean => isUserContextIdentified && value === true;

/** Replaces unsupported and rollout-disabled destinations with the restricted shell. */
export const getGmfAdvisorDestination = (
  destination: string,
  enabled: boolean
): string => {
  const pathname = destination.split(/[?#]/)[0];
  return isGmfAccountPath(pathname) ||
    (enabled && isGmfOrganizationPath(pathname))
    ? destination
    : GMF_ORGANIZATIONS_PATH;
};
